// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__2NYtw","dadosUsuario":"OptionSelect_dadosUsuario__mxhcE","focado":"OptionSelect_focado__L4KUP"};